var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "non-hover-inner",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.869 7.07a1.88 1.88 0 0 1 1.322 1.322c.321 1.174.309 3.62.309 3.62s0 2.434-.309 3.608a1.879 1.879 0 0 1-1.322 1.322c-1.174.31-5.869.31-5.869.31s-4.683 0-5.869-.322a1.88 1.88 0 0 1-1.322-1.322C4.5 14.446 4.5 12 4.5 12s0-2.434.309-3.608A1.918 1.918 0 0 1 6.13 7.058c1.174-.31 5.869-.31 5.869-.31s4.695 0 5.869.322ZM14.409 12l-3.904 2.249V9.75l3.904 2.25Z",
    fill: "#212A31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "hover-inner",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.869 7.07a1.88 1.88 0 0 1 1.322 1.322c.321 1.174.309 3.62.309 3.62s0 2.434-.309 3.608a1.879 1.879 0 0 1-1.322 1.322c-1.174.31-5.869.31-5.869.31s-4.683 0-5.869-.322a1.88 1.88 0 0 1-1.322-1.322C4.5 14.446 4.5 12 4.5 12s0-2.434.309-3.608A1.918 1.918 0 0 1 6.13 7.058c1.174-.31 5.869-.31 5.869-.31s4.695 0 5.869.322ZM14.409 12l-3.904 2.249V9.75l3.904 2.25Z",
    fill: "red"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.62a4bfcd4f588c5bbc27383784b67271.svg";
export { ForwardRef as ReactComponent };